import * as React from 'react';
import './EditableText.css';


class EditableText extends React.Component<{
  value: string,
  setValue: (value: string) => void,

  className?: string,
  multiLine?: boolean,
  attributes?: React.HTMLAttributes<HTMLSpanElement>,
}> {

  ref = React.createRef<HTMLSpanElement>()

  shouldComponentUpdate(nextProps: any) {
    return !this.ref.current || nextProps.value !== this.ref.current.textContent
  }

  render() {
    const {className, value, attributes = {}} = this.props

    return (
      <span
        ref={this.ref}
        contentEditable={true}
        suppressContentEditableWarning={true}
        onClick={() => this.ref.current && this.ref.current.focus()}
        onInput={this.onInput}
        onKeyDown={this.onKeyDown}
        className={"EditableText " + (className || "")}
        spellCheck={false}
        {...attributes}
      >
        {value}
      </span>
    )
  }

  onInput = () => {
    this.ref.current && this.props.setValue(this.ref.current.textContent || "")
  }

  onKeyDown = (e: React.KeyboardEvent) => {
    if (!this.props.multiLine && e.keyCode === 13) {  // Enter
      e.preventDefault()
    }
  }
}

export default EditableText;



// WEBPACK FOOTER //
// ./src/view/EditableText.tsx